// extracted by mini-css-extract-plugin
export var active = "scrolljackingSlider-module--active--b1d6c";
export var contentAnchor = "scrolljackingSlider-module--contentAnchor--e9b7b";
export var contentItems = "scrolljackingSlider-module--contentItems--7d1a6";
export var contentViewport = "scrolljackingSlider-module--contentViewport--2306d";
export var contentWrapper = "scrolljackingSlider-module--contentWrapper--0bf5c";
export var scrolljackingSlider = "scrolljackingSlider-module--scrolljackingSlider--1accb";
export var tab = "scrolljackingSlider-module--tab--dafea";
export var tabs = "scrolljackingSlider-module--tabs--202db";
export var tabsWrapper = "scrolljackingSlider-module--tabsWrapper--76249";